import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import EntityTab from './EntityTab'
import getEntityNames from './helpers/getEntityNames'

const TabContainer = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  margin-top: 25px;
  margin-bottom: 20px;
`
const TabBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 10px;
  align-items: flex-end;
  border-bottom: 1px solid #dedfe0;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 95%;
`

export default class EntityTabs extends React.Component {
  static propTypes = {
    entities: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }
  renderTabs = () => {
    const { entities, value, onChange } = this.props
    return getEntityNames(entities).map((entity, i) => {
      return (
        <EntityTab
          key={entity.key}
          entity={entity}
          selected={value === i}
          onClick={() => onChange(i)}
          id={`entity_tab_${i}`}
        />
      )
    })
  }
  render() {
    const { onChange, value } = this.props
    const globalEntity = {
      title: null,
      name: 'Global'
    }
    return (
      <TabContainer id="entity-tabs">
        <TabBar>
          {this.renderTabs()}
          <EntityTab
            id="entity_tab_bank_statement"
            value="Bank Statement(s)"
            selected={value === "bank_statement"}
            onClick={() => onChange("bank_statement")}
            entity={{
              title: null,
              name: "Bank Statement(s)",
            }}
          />
          <EntityTab
            value="Global"
            selected={value === 'global'}
            onClick={() => onChange('global')}
            entity={globalEntity}
            id="entity_tab_global"
          >
            Global
          </EntityTab>
        </TabBar>
      </TabContainer>
    )
  }
}